export { default } from './Slider';
export * from './Slider.types';
export { default as sliderClasses } from './sliderClasses';
export * from './sliderClasses';